import { Col, Form, Input, Row, Select } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../components/DraggableModal";
import { SelectProductType, SelectUnitMeasurement } from "../../../../components/selects";
import { EntLivestockTradeActivity } from "../../../../models/organic/livestockTradeActivity";
import SelectCitizenship from "../../../../components/selects/SelectCitizenship";

enum FormField {
  id,
  year,
  citizenshipId,
  hsCode,
  productTypeId,
  operationType,
  unitMeasurementId,
  amount
}

interface IProps {
  show: boolean;
  item: EntLivestockTradeActivity;
  onHide: () => void;
  onSubmit: (pos: EntLivestockTradeActivity) => Promise<boolean>;
}

const operationOptions = [
  { label: "Импорт", value: "IMPORT" },
  { label: "Экспорт", value: "EXPORT" },
];

export const AddLivestockTradeActivityModal = (props: IProps) => {
  const { t } = useTranslation();
  const [form] = useForm();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
	if (props.show) setFieldsFromEntity();
  }, [props.show]);

  const setFieldsFromEntity = (): void => {
	form.setFields([
	  { name: FormField.year, value: props.item.year },
	  { name: FormField.citizenshipId, value: props.item.citizenship?.id },
	  { name: FormField.hsCode, value: props.item.hsCode },
	  { name: FormField.productTypeId, value: props.item.productType?.id },
	  { name: FormField.operationType, value: props.item.operationType },
	  { name: FormField.unitMeasurementId, value: props.item.unitMeasurement?.id },
	  { name: FormField.amount, value: props.item.amount },
	]);
  };

  const setEntityFromFields = (): EntLivestockTradeActivity => {
	let res = _.cloneDeep(props.item);
	res.year = form.getFieldValue(FormField.year);
	res.citizenshipId = form.getFieldValue(FormField.citizenshipId);
	res.hsCode = form.getFieldValue(FormField.hsCode);
	res.productTypeId = form.getFieldValue(FormField.productTypeId);
	res.operationType = form.getFieldValue(FormField.operationType);
	res.unitMeasurementId = form.getFieldValue(FormField.unitMeasurementId);
	res.amount = form.getFieldValue(FormField.amount);
	return res;
  }

  const handleSubmit = async () => {
	setLoading(true);
	try {
	  await form.validateFields();
	  const data = setEntityFromFields();
	  const result = await props.onSubmit(data);
	  if (result) props.onHide()
	} finally {
	  setLoading(false);
	}
  }

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, index) => currentYear - index);

  return (
	<>
	  <DraggableModal
		title={ props.item.id === null ? t('general.add') : t('general.edit') }
		visible={ props.show }
		onCancel={ props.onHide }
		onSubmit={ handleSubmit }
		submitLoading={ loading }
		width={ 800 }
	  >
		<Form
		  initialValues={ { remember: true } }
		  autoComplete="off"
		  layout="vertical"
		  form={ form }
		>
		  <Row style={ { margin: 0 } } gutter={ 16 }>
			<Col className="gutter-row" span={ 12 }>
			  <Form.Item
				label={ t('year') }
				name={ FormField.year }
				rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
			  >
				<Select
				  placeholder={ t("msg.selectPlaceholder") }
				  allowClear
				>
				  { years.map((year) => (
					<Select.Option key={ year } value={ year }>
					  { year }
					</Select.Option>
				  )) }
				</Select>
			  </Form.Item>
			  <Form.Item
				label={ t('Область') }
				name={ FormField.citizenshipId }
				rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
			  >
				<SelectCitizenship/>
			  </Form.Item>
			  <Form.Item
				label={ t('Код ТНВЭД') }
				name={ FormField.hsCode }
				rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
			  >
				<Input type="text"/>
			  </Form.Item>
			  <Form.Item
				label={ t('Тип продукта') }
				name={ FormField.productTypeId }
				rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
			  >
				<SelectProductType/>
			  </Form.Item>
			</Col>
			<Col className="gutter-row" span={ 12 }>
			  <Form.Item
				label={ t('Направление') }
				name={ FormField.operationType }
				rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
			  >
				<Select
				  placeholder={ t("Выберите направление") }
				  options={ operationOptions }
				  allowClear
				/>
			  </Form.Item>
			  <Form.Item
				label={ t('Единица измерения') }
				name={ FormField.unitMeasurementId }
				rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
			  >
				<SelectUnitMeasurement/>
			  </Form.Item>
			  <Form.Item
				label={ t('Количество') }
				name={ FormField.amount }
				rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
			  >
				<Input type="number"/>
			  </Form.Item>
			</Col>
		  </Row>
		</Form>
	  </DraggableModal>
	</>
  )
}